import { createStyles, makeStyles } from '@material-ui/styles';

const style = () =>
  createStyles({
    root: {
      fontWeight: 500,
      fontSize: '12px',
      userSelect: 'none',
      display: 'flex',
      gap: '8px',
      alignItems: 'center',
      marginBottom: '10px',
      width: 'max-content'
    },
    noMargin: {
      marginBottom: '0'
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
